import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField, DialogActions, Button, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';
import { AlertMessagesContext } from 'react-alert-messages';
import ChargeServices from 'services/ChargeServices';

export default function ChargeGroupEditDialog({ chargeGroup, handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const [isLoading, setLoading] = useState(false);
  const [chargeGroupData, setChargeGroupData] = useState(chargeGroup);
  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleUpdateVariant = async () => {
    setLoading(true);
    try {
      const resp = await ChargeServices.updateChargeGroup(chargeGroupData.id, chargeGroupData);
      postAlertMessage({ type: 'success', text: 'Charge Group updated successfully.' });
      handleSuccess(resp);
      handleClose();
    } catch (error) {
      postAlertMessage({ type: 'error', text: error?.message || 'Failed to update charge group.' });
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Edit Charge Group')}</h2>
            <IconButton onClick={handleClose} edge="end">
              <CloseIcon />
            </IconButton>
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Charge group name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={chargeGroupData.name}
                  onChange={(e) => setChargeGroupData({ ...chargeGroupData, name: e.target.value })}
                  disabled={isLoading}
                />
              </Grid>
            </Grid>
          </div>

          <div className={styles.footSec}>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose} disabled={isLoading}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!chargeGroupData.name.trim() || isLoading}
                onClick={handleUpdateVariant}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Updating...')}
                  </>
                ) : (
                  tCommon('Update')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
